import React from 'react'
import { SvgProps } from './SvgProps'
import { svgTransform } from './svgTramsform'

export const VacanciesCircleSvg = ({ size }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: svgTransform(size),
      }}
    >
      <path
        d="M0 3C0 1.89543 0.895431 1 2 1H22C23.1046 1 24 1.89543 24 3V21C24 22.1046 23.1046 23 22 23H2C0.89543 23 0 22.1046 0 21V3Z"
        fill="#0CB200"
      />
      <path
        d="M15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9Z"
        fill="white"
      />
      <path
        d="M9 14C9 12.8954 9.89543 12 11 12H13C14.1046 12 15 12.8954 15 14V19H9V14Z"
        fill="white"
      />
    </svg>
  )
}
